import LoyaltyInput from './loyalty-input.vue';

export default LoyaltyInput;
